module.exports = __webpack_public_path__ + "531372a66e302463fdd1813808be0a54.svg";